import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class WelcomeEmailConfirmationRoute extends Route {
  @service store;
  @service segment;
  @service intl;

  activate() {
    this.segment.track('onboarding_partner_credentials_started');

    let redirection = this.modelFor('welcome').redirection;
    if (redirection.isLegalPlace) {
      this.segment.track('onboarding_partner_register_redirected_from_lp');
    }
  }

  async afterModel(model) {
    await model.user.confirmEmail();
  }
}
